import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const AIMLEssentials = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  const scrollToSection = (id) => {
    const targetElement = document.getElementById(id);
    window.scrollTo({
      top: targetElement.offsetTop - 60, // Adjust this value to add space above the section
      behavior: "smooth",
    });
  };

  return (
    <div>
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">
            Home / Training / AI & Machine Learning Essentials
          </h6>
          <hr />
          <h1 className="banner-title">
            AI & Machine Learning Essentials Bootcamp
          </h1>
          <p>
            Master AI & Machine Learning. Learn Python, Data Science, Neural
            Networks, Deep Learning, and more!
          </p>
          <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let’s talk <span className="arrow">→</span>
            </Link>
          </button>
        </div>
        <img
          src="https://img.freepik.com/free-photo/programming-background-collage_23-2149901780.jpg"
          alt="AI and Machine Learning Banner"
          className="banner-image"
        />
      </section>

      <section id="ai-ml-essentials" className="p_3">
        <div className="container-xl">
          <div className="row about_pg1">
            <div className="col-md-12">
              <div className="about_pg1l mt-5">
                <h6 className="col_yell text-center">
                  AI & Machine Learning Essentials
                </h6>
                <h2 className="mt-3 mb-3 text-center">
                  Master the Fundamentals of AI and Machine Learning
                </h2>
                <p className="text-center">
                  Dive deep into the world of Artificial Intelligence and
                  Machine Learning. This course covers everything from basic
                  machine learning concepts to advanced algorithms, preparing
                  you to build intelligent systems that learn from data.
                </p>
              </div>
            </div>
            {/* <div className="col-md-6">
              <div className="about_pg1r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <a href="#">
                      <img
                        src="https://img.freepik.com/free-photo/programming-background-collage_23-2149901780.jpg"
                        className="w-100"
                        alt="AI and Machine Learning"
                      />
                    </a>
                  </figure>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <hr />

      <section id="ai-ml-course-content">
        <div className="container-xl mt-5">
          <h2 className="mb-2">
            AI & Machine Learning Essentials Course Content
          </h2>
          <p className="mb-4">
            A step-by-step roadmap to mastering AI and Machine Learning
          </p>

          <div className="accordion" id="aiMlAccordion">
            {/* 1. Introduction to AI & ML */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="aiHeadingOne">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#aiCollapseOne"
                  aria-expanded="true"
                  aria-controls="aiCollapseOne"
                >
                  1. Introduction to AI & Machine Learning
                </button>
              </h2>
              <div
                id="aiCollapseOne"
                className="accordion-collapse collapse show"
                aria-labelledby="aiHeadingOne"
                data-bs-parent="#aiMlAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    <li>
                      Overview of Artificial Intelligence and Machine Learning
                    </li>
                    <li>History and Evolution of AI</li>
                    <li>Applications of AI and ML in various industries</li>
                    <li>
                      Understanding supervised, unsupervised, and reinforcement
                      learning
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 2. Data Preprocessing */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="aiHeadingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#aiCollapseTwo"
                  aria-expanded="false"
                  aria-controls="aiCollapseTwo"
                >
                  2. Data Preprocessing and Cleaning
                </button>
              </h2>
              <div
                id="aiCollapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="aiHeadingTwo"
                data-bs-parent="#aiMlAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    <li>Data collection and understanding data sets</li>
                    <li>Handling missing data and outliers</li>
                    <li>Normalization and Standardization techniques</li>
                    <li>Feature selection and extraction</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 3. Machine Learning Algorithms */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="aiHeadingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#aiCollapseThree"
                  aria-expanded="false"
                  aria-controls="aiCollapseThree"
                >
                  3. Machine Learning Algorithms
                </button>
              </h2>
              <div
                id="aiCollapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="aiHeadingThree"
                data-bs-parent="#aiMlAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    <li>Linear Regression and Logistic Regression</li>
                    <li>Decision Trees and Random Forests</li>
                    <li>Support Vector Machines (SVM)</li>
                    <li>K-Nearest Neighbors (KNN)</li>
                    <li>Naive Bayes and Clustering Algorithms (K-means)</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 4. Deep Learning Introduction */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="aiHeadingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#aiCollapseFour"
                  aria-expanded="false"
                  aria-controls="aiCollapseFour"
                >
                  4. Introduction to Deep Learning
                </button>
              </h2>
              <div
                id="aiCollapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="aiHeadingFour"
                data-bs-parent="#aiMlAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    <li>Neural Networks: Basics and Components</li>
                    <li>Forward and Backpropagation</li>
                    <li>Deep Neural Networks and Activation Functions</li>
                    <li>Introduction to Convolutional Neural Networks (CNN)</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 5. Model Evaluation and Tuning */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="aiHeadingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#aiCollapseFive"
                  aria-expanded="false"
                  aria-controls="aiCollapseFive"
                >
                  5. Model Evaluation and Tuning
                </button>
              </h2>
              <div
                id="aiCollapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="aiHeadingFive"
                data-bs-parent="#aiMlAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    <li>Overfitting and Underfitting</li>
                    <li>Cross-Validation and Hyperparameter Tuning</li>
                    <li>Confusion Matrix, Precision, Recall, and F1 Score</li>
                    <li>Model Optimization and Regularization</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* 6. Practical Applications and Projects */}
            <div className="accordion-item">
              <h2 className="accordion-header" id="aiHeadingSix">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#aiCollapseSix"
                  aria-expanded="false"
                  aria-controls="aiCollapseSix"
                >
                  6. Practical Applications and Projects
                </button>
              </h2>
              <div
                id="aiCollapseSix"
                className="accordion-collapse collapse"
                aria-labelledby="aiHeadingSix"
                data-bs-parent="#aiMlAccordion"
              >
                <div className="accordion-body">
                  <ul>
                    <li>Building Real-World AI Models</li>
                    <li>
                      Implementing AI in Healthcare, Finance, and E-Commerce
                    </li>
                    <li>Working on Kaggle Competitions and Projects</li>
                    <li>Deploying AI Models for Production</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div
            className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4"
            style={{ backgroundColor: "black", color: "white" }}
          >
            <div className="col-md-8">
              <div className="serv_h3l">
                <h6 className="">Benefits</h6>
                <h2 className="text-white">
                  Master AI & Machine Learning and boost your career.
                </h2>
                <p className="text-white mt-3">
                  "Join our AI & Machine Learning Essentials Bootcamp to gain
                  practical skills in Python, Data Science, Deep Learning, and
                  Neural Networks. Prepare yourself for real-world AI challenges
                  and enhance your ability to work with cutting-edge
                  technologies."
                </p>
                <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Contact Us <span className="arrow">→</span>
            </Link>
          </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="AI and Machine Learning Bootcamp"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AIMLEssentials;
